import { render } from "./userCard.vue?vue&type=template&id=e972d8b4&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"

import "./userCard.vue?vue&type=style&index=0&id=e972d8b4&lang=scss&scoped=true"
import "./userCard.vue?vue&type=style&index=1&id=e972d8b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e972d8b4"]])

export default __exports__